<div class="modal-dialog"
     id="new-request">
  <div class="modal-content p-0">
    <div class="modal-header">
      <button (click)="noAction()"
              class="close"
              data-dismiss="modal"
              type="button">
        <div class="dialog-close"></div>
      </button>
      <span
        *ngIf="addOrUpdateBusinessOptions.business.BusinessId === undefined">{{ 'Insert' | translate }}
        : {{ 'Business' | translate }}</span>
      <span
        *ngIf="addOrUpdateBusinessOptions.business.BusinessId !== undefined">{{ 'Update' | translate }}
        : {{ 'Business' | translate }}</span>
    </div>
  </div>
</div>
<mat-dialog-content class="mat-typography">
  <div class="row my-4 pb-1 ">
    <div class="col-md-6 col-12">
      <app-frontend-input [(value)]="title"
                          [required]="true"
                          [title]="'Title'"
                          [type]="'text'"></app-frontend-input>
    </div>
    <div class="col-md-6 col-12">
      <app-frontend-input [(value)]="standardCode"
                          [required]="false"
                          [title]="'StandardCode'"
                          [type]="'text'"></app-frontend-input>
    </div>
    <div class="col-md-6 col-12">
      <app-frontend-input [(value)]="priority"
                          [required]="true"
                          [title]="'Priority'"
                          [type]="'number'"></app-frontend-input>
    </div>
    <div class="col-md-6 col-12">
      <app-frontend-input [(value)]="uniqueIdentifier"
                          [required]="false"
                          [title]="'UniqueIdentifier'"
                          [type]="'text'"></app-frontend-input>
    </div>
    <div class="col-md-6 col-12">
      <app-frontend-file-chooser [(files)]="iconFile"
                                 [accept]="'png'"
                                 [title]="'Icon'"></app-frontend-file-chooser>
    </div>
    <div class="col-md-6 col-12">
      <app-frontend-button (click)="onDetailClicked()"
                           [Image]="true"
                           [class]="'card-green-light'"
                           [endpoint]=""
                           [src]="'icons/tick-square.svg'"
                           [title]="'Details'"
                           [validationRequired]="true"
                           class="mt-2">
      </app-frontend-button>
    </div>
  </div>
</mat-dialog-content>
<div class="dialog-footer">
  <mat-dialog-actions align="end"
                      class="py-0">
    <div class="col-12 d-flex align-items-center justify-content-end footer"
         style="gap: 16px">
      <app-frontend-button (onSubmit)="onSubmitClicked()"
                           [Image]="true"
                           [class]="'card-green'"
                           [disabled]="false"
                           [src]="'/icons/tick-square.svg'"
                           [title]="'Submit'"
                           [validationRequired]="true">
      </app-frontend-button>
      <app-frontend-button (click)="noAction()"
                           [Image]="true"
                           [class]="'card-yellow'"
                           [disabled]="false"
                           [src]="'/icons/close-square.svg'"
                           [title]="'Cancel'">
      </app-frontend-button>
    </div>
  </mat-dialog-actions>
</div>
